import { render, staticRenderFns } from "./PopupRiskInfoEp2_3x3.vue?vue&type=template&id=ff2d2f30&scoped=true"
import script from "./PopupRiskInfoEp2_3x3.vue?vue&type=script&lang=js"
export * from "./PopupRiskInfoEp2_3x3.vue?vue&type=script&lang=js"
import style0 from "./PopupRiskInfoEp2_3x3.vue?vue&type=style&index=0&id=ff2d2f30&prod&lang=scss&scoped=true"
import style1 from "./PopupRiskInfoEp2_3x3.vue?vue&type=style&index=1&id=ff2d2f30&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2d2f30",
  null
  
)

export default component.exports